import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  NgZone,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[protectInnerText]',
  standalone: true,
})
export class ProtectInnerTextDirective implements AfterViewInit, OnDestroy {
  originalText = input<string>('', { alias: 'protectInnerText' });

  #observer!: MutationObserver;

  readonly #el = inject(ElementRef<HTMLElement>);
  readonly #renderer = inject(Renderer2);
  readonly #ngZone = inject(NgZone);

  ngAfterViewInit(): void {
    this.#ngZone.runOutsideAngular(() => {
      this.#startMutationObserver();
    });
  }

  ngOnDestroy(): void {
    this.#observer?.disconnect();
  }

  #startMutationObserver(): void {
    const element = this.#el.nativeElement;

    this.#observer = new MutationObserver(() => {
      const currentText = element.textContent?.trim();
      if (currentText !== this.originalText()) {
        this.#renderer.setProperty(element, 'textContent', this.originalText());
      }
    });

    this.#observer.observe(element, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }
}
